module.exports = __webpack_public_path__ + "img/categorie-nos-engagements-small.d0ea5388.jpg";